import styled from "styled-components/macro";
import { H3 } from "src/components/common/Typography";
import { AppColors } from "../Styling";

export const CenteredLightHeading = styled(H3)`
  text-align: center;
  color: ${AppColors.neutral["light-navy-3"]};
  margin-top: 48px;
`;
